import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, primaryGradient, transition } from './glowUtil'

export default genComponentStyleHook(['Tag', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [componentCls]: {
      transition,
      borderRadius: '999px !important',
      fontWeight: 500,

      [`&:not(${componentCls}-checkable)`]: {
        borderColor: `${purple[500]}25`,
        '&:hover': {
          borderColor: `${purple[500]}50`,
        },
      },

      [`&${componentCls}-checkable`]: {
        borderColor: 'transparent !important',
        borderRadius: '999px !important',
        transition,
        '&-checked': {
          background: `${primaryGradient} !important`,
          color: '#fff !important',
          boxShadow: `0 2px 6px ${purple[600]}30`,
        },
        '&:hover': {
          color: `${purple[500]} !important`,
        },
      },
    },
  }
})
